import ListingInfo from './listingInfo'

export default ListingInfo
